// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e87c4720","239":"4c30e10b","732":"b850e9f8"}[chunkId] + ".chunk.js";
};